
import { TURKEY_CITIES } from '../constants';

export const locationService = {
  getCities: () => {
    const allCities = Object.keys(TURKEY_CITIES);
    
    // Özel sıralama: Popüler şehirler önce, sonra alfabetik
    const priorityCities = ['İstanbul', 'Ankara', 'İzmir', 'Bursa', 'Antalya', 'Adana', 'Gaziantep', 'Konya', 'Kayseri', 'Mersin'];
    
    const priorityList: string[] = [];
    const otherCities: string[] = [];
    
    // Önce öncelikli şehirleri ekle
    priorityCities.forEach(city => {
      if (allCities.includes(city)) {
        priorityList.push(city);
      }
    });
    
    // Diğer şehirleri alfabetik sırala
    allCities
      .filter(city => !priorityCities.includes(city))
      .sort((a, b) => a.localeCompare(b, 'tr'))
      .forEach(city => otherCities.push(city));
    
    return [...priorityList, ...otherCities];
  },
  
  getDistricts: (city: string) => {
    if (!city || !TURKEY_CITIES[city]) return [];
    return TURKEY_CITIES[city].sort((a, b) => a.localeCompare(b, 'tr'));
  }
};
